import React from 'react'
import styled from 'styled-components'
import Container from './Container'
import { useTranslations } from '../../utils/Text'

const Img = styled.img`
  width: ${props => (props.width ? `${props.width}` : '100%')};
  max-width: ${props =>
    props.maxWidth ? `${props.maxWidth}px` : 'auto'};
  min-width: ${props =>
    props.minWidth ? `${props.minWidth}px` : 'auto'};
  height: ${props => (props.height ? `${props.height}` : 'auto')};
`

const Image = ({ ...props }) => {
  const {
    src,
    alt = '',
    marginT = 0,
    marginB = 0,
    marginL = 0,
    marginR = 0,
    paddingT = 0,
    paddingB = 0,
    paddingL = 0,
    paddingR = 0,
    width,
    maxWidth,
    minWidth,
    height,
    className,
    classNameImage,
    optional,
    ...rest
  } = props

  const altToShow = useTranslations(alt)

  if (altToShow === null && optional) return null
  return (
    <Container
      marginT={marginT}
      marginB={marginB}
      marginL={marginL}
      marginR={marginR}
      paddingT={paddingT}
      paddingB={paddingB}
      paddingL={paddingL}
      paddingR={paddingR}
      maxWidth={maxWidth}
      minWidth={minWidth}
      className={className}
    >
      <Img
        src={src}
        alt={altToShow}
        maxWidth={maxWidth}
        minWidth={minWidth}
        height={height}
        width={width}
        classNameImage={classNameImage}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
    </Container>
  )
}

export default Image
